/// <reference lib="dom" />
// Runs only in the web build (printing through an iframe); the native tsconfig has no DOM types.
import { generateReceiptHTML, ReceiptOptions } from './ReceiptHTML';

// Same hidden-iframe technique the staff web frontend's usePrint.ts uses:
// write the receipt into an off-screen iframe and print that iframe's window,
// rather than opening a new tab (which a popup blocker can swallow). Web only
// - this is never imported from the native (.tsx) fee screen.
export function printFeeReceipt(
  installment: any,
  studentName: string,
  options?: ReceiptOptions,
) {
  const html = generateReceiptHTML(installment, { name: studentName }, options);

  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0px';
  iframe.style.height = '0px';
  iframe.style.border = 'none';
  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow?.document;
  if (!iframeDoc) {
    document.body.removeChild(iframe);
    return;
  }

  iframeDoc.open();
  iframeDoc.write(html);
  iframeDoc.close();

  // Slight delay so the content (and logo) is rendered in the iframe before
  // printing; removal waits a little longer so the print dialog can open.
  setTimeout(() => {
    try {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
    } catch (e) {
      console.error('Print failed', e);
    } finally {
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      }, 1000);
    }
  }, 500);
}
